import { render, staticRenderFns } from "./PresetRow.vue?vue&type=template&id=0b2e88ea&scoped=true&lang=pug&"
import script from "./PresetRow.vue?vue&type=script&lang=ts&"
export * from "./PresetRow.vue?vue&type=script&lang=ts&"
import style0 from "./PresetRow.vue?vue&type=style&index=0&id=0b2e88ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e88ea",
  null
  
)

component.options.__file = "PresetRow.vue"
export default component.exports